import { ContractConcession } from "./contract-concession";
import { Contract } from "./contract";

export class ContractConcessionDetail {
    id?: string;
    index?: number;
    contractConcession?: ContractConcession;
    contract?: Contract | null;
    isCreationMode?: boolean;
    isEditMode?: boolean;
    isReadOnlyMode?: boolean;

    constructor(contractConcessionDetail?: ContractConcessionDetail) {
        this.id = contractConcessionDetail?.id;
        this.index = contractConcessionDetail?.index;
        this.contractConcession = contractConcessionDetail?.contractConcession;
        this.contract = contractConcessionDetail?.contract;
        this.isCreationMode = contractConcessionDetail?.isCreationMode;
        this.isEditMode = contractConcessionDetail?.isEditMode;
        this.isReadOnlyMode = contractConcessionDetail?.isReadOnlyMode;
    }
}
